<template>
  <div class="modal fade" ref="highlightModal" id="highlightModal" tabindex="-1" role="dialog"
    aria-labelledby="createHighlightModal" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="onSubmit" class="mb-3">
          <div class="modal-header">
            <h5>{{ $t("js.highlight_modal.header") }}</h5>
          </div>
          <div class="modal-body">
            <div v-if="activeHighlight">
              <button type="button" class="btn btn-sm btn-danger float-end" :disabled="readonly"
                @click="removeHighlight">{{ $t("js.actions.remove") }}</button>
              <h5>{{ $t("js.highlight_modal.active_highlight") }}</h5>
              <PresentPost v-if="highlightedPost" :post="highlightedPost" class="mb-3" />
              <div v-if="activeHighlight.highlight_message">
                <label class="font-weight-bold">{{ $t("js.highlight_modal.message_label_frontend") }}</label>
                <div style="white-space: pre-wrap; overflow-wrap: break-word;">{{ activeHighlight.highlight_message }}
                </div>
              </div>
              <hr>
            </div>
            <div>
              <h5>{{ $t("js.highlight_modal.new_highlight") }}</h5>
              <div class="font-weight-bold mb-2" v-if="postToHighlight">Reference</div>
              <PresentPost v-if="postToHighlight" :post="postToHighlight" class="mb-3" />
              <label><b>{{ $t("js.highlight_modal.message_label_backend") }}</b></label>
              <textarea class="form-control" rows="3" v-model="customMessage" autofocus></textarea>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t("js.actions.cancel")
              }}</button>
            <button type="submit" class="btn btn-theme" :disabled="readonly">{{ $t("js.actions.submit") }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "pinia";
import { defineComponent } from "vue";
import PresentPost from "../shared/PresentPost.vue";
import apiClient from "@/entrypoints/frontend/apiClient";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import { useVotingModulesStore } from "@/entrypoints/stores/voting_modules";
import type { HighlightPost } from "@/types";

export default defineComponent({
  name: "HighlightModal",
  components: { PresentPost },
  data() {
    return {
      customMessage: "",
    }
  },
  computed: {
    ...mapState(usePresentationStore, ["readonly"]),
    ...mapState(useVotingModulesStore, ["postToHighlight", "activeHighlight"]),
    highlightedPost() {
      return this.activeHighlight.highlight_post;
    }
  },
  methods: {
    onSubmit() {
      const highlight: HighlightPost = { highlight_message: this.customMessage, highlight_post: null };
      if (this.postToHighlight) highlight.highlight_post = this.postToHighlight;
      this.submitHighlight(highlight);
      this.customMessage = "";
      $("#highlightModal").modal("hide");
    },
    removeHighlight() {
      this.submitHighlight();
    },
    async submitHighlight({ highlight_message, highlight_post }: HighlightPost = { highlight_message: "", highlight_post: null }) {
      // Expected url like /backend/(:locale/)organisations/:organisation_id/elections/:election_id/live/presentation
      // Parse route
      const routeRegexp = new RegExp("^/backend/((?<locale>[^/]+)/)?organisations/(?<organisation_id>\\d+)/elections/(?<election_id>\\d+)/live/presentation", "i");
      const match = window.location.pathname.match(routeRegexp);
      const organisationId = match.groups.organisation_id;
      const electionId = match.groups.election_id;
      await apiClient.patch(`/backend/organisations/${organisationId}/elections/${electionId}`, {
        election: {
          highlight_message,
          highlight_post,
        },
      });
    },
  },
});
</script>
